import type { MarketingTranslator } from '@/i18n/marketing'
export interface ConsentTermsRow {
  readonly columns: readonly string[]
}

export interface ConsentTermsTable {
  readonly headers: readonly string[]
  readonly rows: readonly ConsentTermsRow[]
}

export interface ConsentTermsContent {
  readonly title: string
  readonly intro?: string
  readonly table: ConsentTermsTable
  readonly footnotes: readonly string[]
}

export function getPrivacyConsentContent(mt: MarketingTranslator) {
  const PRIVACY_CONSENT_CONTENT: ConsentTermsContent = {
    title: mt('consent.PRIVACYCONSENTCONTENT.title'),
    table: {
      headers: [mt('consent.PRIVACYCONSENTCONTENT.table.headers.0'), mt('consent.PRIVACYCONSENTCONTENT.table.headers.1'), mt('consent.PRIVACYCONSENTCONTENT.table.headers.2')],
      rows: [
        {
          columns: [
            mt('consent.PRIVACYCONSENTCONTENT.table.rows.0.columns.0'),
            mt('consent.PRIVACYCONSENTCONTENT.table.rows.0.columns.1'),
            mt('consent.PRIVACYCONSENTCONTENT.table.rows.0.columns.2'),
          ],
        },
      ],
    },
    footnotes: [
      mt('consent.PRIVACYCONSENTCONTENT.footnotes.0'),
      mt('consent.PRIVACYCONSENTCONTENT.footnotes.1'),
    ],
  }
  return PRIVACY_CONSENT_CONTENT
}

export function getMarketingConsentContent(mt: MarketingTranslator) {
  const MARKETING_CONSENT_CONTENT: ConsentTermsContent = {
    title: mt('consent.MARKETINGCONSENTCONTENT.title'),
    intro:
      mt('consent.MARKETINGCONSENTCONTENT.intro'),
    table: {
      headers: [mt('consent.MARKETINGCONSENTCONTENT.table.headers.0'), mt('consent.MARKETINGCONSENTCONTENT.table.headers.1'), mt('consent.MARKETINGCONSENTCONTENT.table.headers.2')],
      rows: [
        {
          columns: [
            mt('consent.MARKETINGCONSENTCONTENT.table.rows.0.columns.0'),
            mt('consent.MARKETINGCONSENTCONTENT.table.rows.0.columns.1'),
            mt('consent.MARKETINGCONSENTCONTENT.table.rows.0.columns.2'),
          ],
        },
      ],
    },
    footnotes: [
      mt('consent.MARKETINGCONSENTCONTENT.footnotes.0'),
      mt('consent.MARKETINGCONSENTCONTENT.footnotes.1'),
    ],
  }
  return MARKETING_CONSENT_CONTENT
}
